
$(document).ready(function () {

  $('.accordions__accordion').on('click', function (e) {
    // Check if the clicked element is a link
    if ($(e.target).is('a')) {
      // Clicked element is a link, prevent collapsing
      e.stopPropagation();
    } else {
      // Clicked element is not a link, toggle the accordion
      $(this).children('.accordions__wrapper').slideToggle();
      $(this).children().children('.accordions__accordion-arrow').toggleClass('accordion-open');
    }
  });
});